module.exports = __webpack_public_path__ + "img/welcome_sales_partner.70431c97.png";